module.exports = __webpack_public_path__ + "img/信息发布.06c7479f.svg";